import { EGeoSearchTypes } from '../constants';
import { ESuggestType } from '@cian/geosuggest-widget';
import { EGeoTypes } from '../constants/geoTypes';
import { IGeoStep } from '../types';
import { EStepField } from '../constants/stepField';

const MAP_SEARCH_TYPES = {
  [EGeoSearchTypes.REGION]: [
    {
      field: EStepField.area,
      title: 'Выберите районы поиска',
      description: 'Пропустите этот вопрос, если район поиска не имеет значения',
      types: [ESuggestType.city, ESuggestType.district, ESuggestType.road],
      placeholder: 'Населенный пункт, район или шоссе',
      placeholderExtra: 'Выберите еще населенный пункт, район или шоссе',
    },
  ],
  [EGeoSearchTypes.REGION_WITH_UNDERGROUND]: [
    {
      field: EStepField.area,
      title: 'Выберите районы поиска',
      description: 'Пропустите этот вопрос, если район поиска не имеет значения',
      types: [ESuggestType.city, ESuggestType.district, ESuggestType.road, ESuggestType.underground],
      placeholder: 'Населенный пункт, метро, район или шоссе',
      placeholderExtra: 'Выберите еще населенный пункт, метро, район или шоссе',
    },
  ],
  [EGeoSearchTypes.CITY_WITH_DISTRICTS_UNDERGROUND]: [
    {
      field: EStepField.districts,
      title: 'Выберите районы',
      description: 'Пропустите этот вопрос, если район не имеет значения',
      types: [ESuggestType.district],
      placeholder: 'Название района',
      placeholderExtra: 'Выберите еще район',
    },
    {
      field: EStepField.undergrounds,
      title: 'Метро рядом',
      description: 'Пропустите этот вопрос, если метро не имеет значения',
      types: [ESuggestType.underground],
      placeholder: 'Станция метро',
      placeholderExtra: 'Выберите еще станцию',
    },
  ],
  [EGeoSearchTypes.CITY_WITH_DISTRICTS]: [
    {
      field: EStepField.districts,
      title: 'Выберите районы',
      description: 'Пропустите этот вопрос, если район не имеет значения',
      types: [ESuggestType.district],
      placeholder: 'Название района',
      placeholderExtra: 'Выберите еще район',
    },
  ],
  [EGeoSearchTypes.CITY]: [
    {
      field: EStepField.streets,
      title: 'Выберите улицы',
      description: 'Пропустите этот вопрос, если улица не имеет значения',
      types: [EGeoTypes.street],
      placeholder: 'Улица',
      placeholderExtra: 'Выберите еще улицу',
    },
  ],
};

export const getExtraSteps = (searchType: EGeoSearchTypes): IGeoStep[] => {
  return MAP_SEARCH_TYPES[searchType] || [];
};
